(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabUpdateScriptsController', TabUpdateScriptsController);

    TabUpdateScriptsController.$inject = ['$scope', '$state', 'TabUpdateScripts', 'ParseLinks', 'AlertService', 'DataUtils', 'pagingParams', 'TabObjectTypes', 'paginationConstants'];

    function TabUpdateScriptsController($scope, $state, TabUpdateScripts, ParseLinks, AlertService, DataUtils, pagingParams, TabObjectTypes, paginationConstants) {
        var vm = this;
        vm.tabUpdateScripts = [];
        vm.predicates = pagingParams.predicates;
        vm.loadPage = loadPage;
        vm.loadFilter = loadFilter;
        vm.currentState = "tab-update-scripts";
        vm.objectType = {};
        vm.objectType.id = pagingParams.objectType;
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);
        vm.loadFilter();

        //Aggiunta per impaginazione
        vm.transition = transition;
        vm.charToSearch = pagingParams.search;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadFilter() {
            TabObjectTypes.query({
                page: 0,
                size: 1000
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.objectTypes = data;
                vm.objectTypes.unshift({
                    id: -1,
                    objectTypeName: "All"
                });
                vm.objectTypes.forEach(function (value) {
                    if (value.id == pagingParams.objectType) {
                        vm.objectType = value;
                    }
                });
            }

            function onError() {}
        }

        vm.loadAll = function () {
            var body = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                query: vm.charToSearch,
                objectType: vm.objectType.id == -1 ? null : vm.objectType.id
            };

            TabUpdateScripts.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.tabUpdateScripts = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.tabUpdateScripts = data;
                if (vm.page == 0 && (vm.page < vm.links['last']))
                    vm.loadPage();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            body.query = vm.charToSearch;
        };

        vm.reset = function () {
            vm.page = 0;
            vm.tabUpdateScripts = [];
            var orderCall = vm.loadAll();
        };

        //Aggiunta per impaginazione
        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                sort: sort(),
                search: vm.charToSearch,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                listFilter: vm.listFilter
            }, {notify: notify, location: "replace"});
        }

        vm.search = function () {
            pagingParams.page = 1;
            vm.loadAll();
            vm.transition(false);
        };

        vm.loadAll();
    }
})();
